var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"hideModalButtons":"","center":"","size":"extra-large","title":_vm.$route.query.name,"customClose":_vm.close}},[_c('img',{staticClass:"zoomed-file",attrs:{"src":_vm.$route.query.url,"alt":"zoomed file"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae17454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/File.vue
// module id = null
// module chunks = 